export default __webpack_public_path__ + "static/media/regulatory--weight-limit--g4.0d1fcb42.png";